/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable no-implicit-globals */

function checkJson(jsonStr) { // NOSONAR
  var outputJson = {};

  try {
    if (JSON.parse(jsonStr) && Boolean(jsonStr)) {
      outputJson = JSON.parse(jsonStr);
    }
  } catch (err) {
    outputJson = {};
  }

  return outputJson;
}

function checkNull(domEle) { // NOSONAR
  var returnVal = '{}';

  if (domEle !== null) {
    returnVal = domEle.content;
  }

  return returnVal;
}

function loadInitalContentGa() { // NOSONAR
  var pageStr = document.querySelector('meta[name="gA360page"]');

  window.eddlContext = checkJson(checkNull(pageStr));
}

window.eddlContext = {};
loadInitalContentGa();
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable no-implicit-globals */
